export type DashboardListItem = {
  id: number;
  name: string;
};

export type DashboardListType = {
  id: number;
  name: string;
  icon: string;
  link?: string;
  items: DashboardListItem[];
  open?: boolean;
  hasItems: boolean;
};

export interface DashboardListItems {
  [key: string]: DashboardListType;
}

export enum TourSteps {
  CATALOG = "catalogHealthSteps",
  SUPPLY_CHAIN = "supplyChainSteps",
  BUSINESS = "businessGrowthSteps",
  SELLER_ACCOUNT = "sellerAccountSteps",
}

export enum Languages {
  ENGLISH = "en",
  CHINESE = "zh",
}

export enum SignUpError {
  USER = "username",
  EMAIL = "email",
  PHONE = "phone_no",
}

export enum DialogBoxEvent {
  BACKDROP = "backdropClick",
}
